import { faFlask, faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ParcelResearch, ProjectLink } from "./types";

const STATUS: Record<string, string> = {
  queued: "In wachtrij",
  running: "Bezig",
  completed: "Gereed",
  failed: "Mislukt",
  cancelled: "Geannuleerd",
};

export const ResearchPanel = ({
  researches,
  projectLinks,
  onSelect,
}: {
  researches: ParcelResearch[];
  projectLinks: ProjectLink[];
  onSelect: (id: number) => void;
}) => {
  return (
    <div className="px-2 pb-2">
      {!researches.length && <p className="text-xs text-gray-400">Nog geen kavelonderzoeken</p>}
      <ul className="space-y-1">
        {researches.map((research) => {
          const active = research.status === "queued" || research.status === "running";
          return (
            <li key={research.id}>
              <button
                type="button"
                onClick={() => onSelect(research.id)}
                className="flex w-full items-start gap-2 rounded p-2 text-left hover:bg-gray-50"
              >
                <FontAwesomeIcon
                  icon={active ? faSpinner : faFlask}
                  spin={active}
                  className="mt-0.5 text-dark-green"
                />
                <span className="min-w-0 flex-1">
                  <span className="block truncate text-xs font-bold">
                    {research.targets.map((target) => target.parcelName).join(", ")}
                  </span>
                  <span className="block text-[11px] text-gray-500">
                    {STATUS[research.status] || research.status}
                    {active && research.progressDetail ? ` · ${research.progressDetail}` : ""}
                  </span>
                </span>
              </button>
            </li>
          );
        })}
      </ul>
      {!!projectLinks.length && (
        <div className="min-w-0 overflow-hidden border-t pt-2 mt-2">
          <p className="mb-1 text-[11px] font-bold uppercase tracking-wide text-gray-500">
            Projectlinks
          </p>
          <ul className="space-y-1 text-xs">
            {projectLinks.map((link) => (
              <li key={link.id} className="min-w-0 overflow-hidden">
                <a
                  href={link.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="block truncate text-blue-600 hover:underline"
                  title={link.title || link.publisher || link.url}
                >
                  {link.title || link.publisher || link.url}
                </a>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};
